import React from 'react';
import { useLanguage } from '../LanguageContext';
import { GameResult } from '../types';
import './Results.css';

interface ResultsProps {
  result: GameResult;
  onPlayAgain: () => void;
  onViewLeaderboard: () => void;
  onBackToSongs: () => void;
}

export default function Results({ result, onPlayAgain, onViewLeaderboard, onBackToSongs }: ResultsProps) {
  const { t } = useLanguage();

  const getGrade = (accuracy: number): string => {
    if (accuracy >= 95) return 'S';
    if (accuracy >= 90) return 'A';
    if (accuracy >= 80) return 'B';
    if (accuracy >= 70) return 'C';
    if (accuracy >= 60) return 'D';
    return 'F';
  };

  const grade = getGrade(result.accuracy);

  return (
    <div className="results-container">
      <div className="results-card">
        <h1 className="results-title">{t.results.title}</h1>
        <p className="results-song">{result.songTitle}</p>

        <div className="results-grade-container">
          <div className={`results-grade grade-${grade.toLowerCase()}`}>
            {grade}
          </div>
        </div>

        {result.isNewBest && (
          <div className="new-best-badge">
            {t.results.newBest}
          </div>
        )}

        <div className="results-score">
          <span className="score-label">{t.results.yourScore}</span>
          <span className="score-value">{result.normalizedScore.toLocaleString()}</span>
        </div>

        <div className="results-stats">
          <div className="stat-row">
            <span className="stat-label">{t.results.accuracy}</span>
            <span className="stat-value">{result.accuracy}%</span>
          </div>
          <div className="stat-row">
            <span className="stat-label">{t.results.maxCombo}</span>
            <span className="stat-value">{result.maxCombo}x</span>
          </div>
        </div>

        <div className="results-hits">
          <div className="hit-stat perfect">
            <span className="hit-count">{result.perfectHits}</span>
            <span className="hit-label">{t.results.perfectHits}</span>
          </div>
          <div className="hit-stat good">
            <span className="hit-count">{result.goodHits}</span>
            <span className="hit-label">{t.results.goodHits}</span>
          </div>
          <div className="hit-stat miss">
            <span className="hit-count">{result.missedHits}</span>
            <span className="hit-label">{t.results.missedHits}</span>
          </div>
        </div>

        {result.previousBest && !result.isNewBest && (
          <div className="previous-best">
            {t.results.previousBest} {result.previousBest.toLocaleString()}
          </div>
        )}

        <div className="results-actions">
          <button className="btn btn-primary" onClick={onPlayAgain}>
            {t.results.playAgain}
          </button>
          <button className="btn btn-secondary" onClick={onViewLeaderboard}>
            {t.results.viewLeaderboard}
          </button>
          <button className="btn btn-outline" onClick={onBackToSongs}>
            {t.results.backToSongs}
          </button>
        </div>
      </div>
    </div>
  );
}
